var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray");

var duration = 0;

var ts2sec = function ts2sec(ts) {
  var _ts$split = ts.split(':'),
      _ts$split2 = _slicedToArray(_ts$split, 3),
      h = _ts$split2[0],
      m = _ts$split2[1],
      s = _ts$split2[2];

  return parseFloat(h) * 60 * 60 + parseFloat(m) * 60 + parseFloat(s);
};

module.exports = function (message, progress) {
  if (typeof message === 'string') {
    if (message.startsWith('  Duration')) {
      var ts = message.split(', ')[0].split(': ')[1];
      var d = ts2sec(ts);

      if (duration === 0 || duration > d) {
        duration = d;
      }
    } else if (message.startsWith('frame')) {
      var _ts = message.split('time=')[1].split(' ')[0];
      var t = ts2sec(_ts);
      progress({
        ratio: t / duration
      });
    } else if (message.startsWith('video:')) {
      progress({
        ratio: 1
      });
      duration = 0;
    }
  }
};